import { useLanguage } from "@/context/AppContext";
import { familyMembers } from "@/i18n/translations";

export default function Family() {
  const { t, lang } = useLanguage();
  return (
    <section id="family" className="section family" data-testid="family-section">
      <div className="section-label">{t.family.label}</div>
      <div className="family-intro">
        <h2 data-testid="family-section-title">
          {t.family.l1}
          <br />
          <em>{t.family.l2}</em>
        </h2>
        <p>{t.family.p}</p>
      </div>
      <div className="family-grid">
        {familyMembers.map((m) => (
          <div className="person" key={m.slug} data-testid={`family-card-${m.slug}`}>
            <i>{m.order}</i>
            <span className={`avatar ${m.kind}`} />
            <strong>{m.name[lang]}</strong>
          </div>
        ))}
      </div>
    </section>
  );
}
